<script setup lang="ts">
import { ArrowTurnDownRightIcon } from '@heroicons/vue/24/outline';
import { useSearchFiltersStore } from '@/views/search/searchFiltersStore.ts';

const filters = useSearchFiltersStore();
</script>

<template>
  <div>
    <div v-for="(parent, parentIndex) in filters.categories.filter((x) => !x.child)" :key="parent.id" class="break-inside-avoid-column space-y-0.5">
      <div class="flex items-center">
        <label :for="`filter-categories-${parentIndex}`" class="flex cursor-pointer items-center p-1 px-1.5">
          <span class="group grid size-4 grid-cols-1">
            <input
              :id="`filter-categories-${parentIndex}`"
              v-model="parent.checked"
              :value="parent.id"
              :aria-describedby="`filter-categories-${parentIndex}`"
              type="checkbox"
              class="checked:border-ph-green-600 checked:bg-ph-green-600 indeterminate:border-ph-green-600 indeterminate:bg-ph-green-600 focus-visible:outline-ph-green-600 col-start-1 row-start-1 cursor-pointer appearance-none rounded-sm border border-gray-300 bg-white focus-visible:outline-2 focus-visible:outline-offset-2 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
            />
            <svg class="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25" viewBox="0 0 14 14" fill="none">
              <path class="opacity-0 group-has-checked:opacity-100" d="M3 8L6 11L11 3.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path class="opacity-0 group-has-indeterminate:opacity-100" d="M3 7H11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
          <span class="ml-2 text-sm whitespace-nowrap text-gray-900">{{ parent.text }}</span>
        </label>
      </div>
      <div v-for="(child, childIndex) in filters.categories.filter((x) => x.parentId === parent.id)" :key="child.id">
        <div class="flex items-center">
          <ArrowTurnDownRightIcon aria-hidden="true" class="-mt-1 h-4 pr-0.5 pl-3 text-gray-400" />
          <label :for="`filter-categories-${parentIndex}-${childIndex}`" class="flex cursor-pointer items-center p-1 px-1.5">
            <span class="group grid size-4 grid-cols-1">
              <input
                :id="`filter-categories-${parentIndex}-${childIndex}`"
                v-model="child.checked"
                :value="child.id"
                type="checkbox"
                class="checked:border-ph-green-600 checked:bg-ph-green-600 indeterminate:border-ph-green-600 indeterminate:bg-ph-green-600 focus-visible:outline-ph-green-600 col-start-1 row-start-1 cursor-pointer appearance-none rounded-sm border border-gray-300 bg-white focus-visible:outline-2 focus-visible:outline-offset-2 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
              />
              <svg class="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25" viewBox="0 0 14 14" fill="none">
                <path class="opacity-0 group-has-checked:opacity-100" d="M3 8L6 11L11 3.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path class="opacity-0 group-has-indeterminate:opacity-100" d="M3 7H11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>
            <span class="ml-2 text-sm whitespace-nowrap text-gray-900">{{ child.text }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="css"></style>
